import { fetchApi } from "../utils/fetchApi";

export function fetchStrategyEvaluations({ filter = {}, options = {} }) {
  return fetchApi({ url: 'strategy-evaluations', filter, options });
}
